var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#373737",
  d: "M6.347 16.667q-.561 0-.954-.394A1.3 1.3 0 0 1 5 15.321V5h-.833v-.833H7.5v-.642h5v.642h3.333V5H15v10.32q0 .576-.385.962a1.3 1.3 0 0 1-.962.385zM14.167 5H5.833v10.32q0 .225.144.37a.5.5 0 0 0 .37.143h7.307a.5.5 0 0 0 .353-.16.49.49 0 0 0 .16-.353zm-5.994 9.167h.834v-7.5h-.834zm2.82 0h.833v-7.5h-.833z"
})));
export { SvgDelete as ReactComponent };
export default __webpack_public_path__ + "cc399d80a267a60958b03be796c1e0ca.svg";